import type { IncomingMessage, ServerResponse } from 'node:http';

const LOCALHOST_ORIGIN_RE = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/;

/** Prod app and local dev UI origins allowed to call the loopback shortcut server. */
const FIXED_ALLOWED_ORIGINS = new Set([
  'https://app.buildautomaton.com',
  'http://localhost:3000',
  'http://127.0.0.1:3000',
]);

export function resolveAllowedCorsOrigin(origin: string | undefined): string | null {
  if (!origin) return null;
  if (FIXED_ALLOWED_ORIGINS.has(origin)) return origin;
  if (LOCALHOST_ORIGIN_RE.test(origin)) return origin;
  return null;
}

export function applyCorsHeaders(req: IncomingMessage, res: ServerResponse): boolean {
  const origin = typeof req.headers.origin === 'string' ? req.headers.origin : undefined;
  const allowed = resolveAllowedCorsOrigin(origin);
  if (allowed) {
    res.setHeader('Access-Control-Allow-Origin', allowed);
    res.setHeader('Vary', 'Origin');
    res.setHeader('Access-Control-Allow-Methods', 'GET, OPTIONS');
    res.setHeader('Access-Control-Allow-Headers', 'Authorization, Content-Type');
    res.setHeader('Access-Control-Max-Age', '86400');
  }
  return allowed != null;
}
